require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./configure-the-application-schema-for-caaml.json") })
        }
      }, "path---configure-the-application-schema-for-caaml");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---configure-the-application-schema-for-caaml!./.cache/json/configure-the-application-schema-for-caaml.json
// module id = 365
// module chunks = 231608221292675